import { useState } from "react";
import { useIntl } from "react-intl";
import { FileDoneOutlined, MinusOutlined } from "@ant-design/icons";
import { Layout, Typography, Space, Button } from "antd";

const { Header } = Layout;
const { Text } = Typography;

const ToDoHeader = (props) => {
  const { minimize } = props;
  const intl = useIntl();

  return (
    <Header className="todolist_header">
      <Space direction="horizontal" size="middle">
        <FileDoneOutlined style={{ color: "#ffffff" }} />
        <Text style={{ color: "#ffffff" }}>
          {intl.formatMessage({
            id: "app.crm.to_do_action_text",
          })}
        </Text>
      </Space>
      <Button
        type="text"
        shape="circle"
        icon={<MinusOutlined style={{ color: "#ffffff" }} />}
        style={{ marginTop: "8px" }}
        onClick={minimize}
      />
    </Header>
  );
};

export default ToDoHeader;
